module.exports = __webpack_public_path__ + "media/new-pdf-report-layout/homologacja-001b1f1f.png";